import ywk from './ywk'

export default {
  install (Vue, pluginOptions = {}) {
    /**
     * 注册alert
     * @type {[type]}
     */
    Vue.prototype.$alert = (type, msg, callback) => {
      ywk.alertFn(type, msg, callback)
    }
  }
}
